module.exports = __webpack_public_path__ + "static/img/zt2.4f29263.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/zt2.png
// module id = 306
// module chunks = 34